import { English, Hindi, Kannada, Malayalam, Tamil, Telugu } from '@quark/icons'
import { Locale } from '@enums/strapiTypesAndOperators'

export const LOCALE_CONFIG = {
  [Locale.English]: {
    icon: <English height={20} width={20} />,
    name: 'English',
  },
  [Locale.Hindi]: {
    icon: <Hindi height={20} width={20} />,
    name: 'Hindi',
  },
  [Locale.Tamil]: {
    icon: <Tamil height={20} width={20} />,
    name: 'Tamil',
  },
  [Locale.Telugu]: {
    icon: <Telugu height={20} width={20} />,
    name: 'Telugu',
  },
  [Locale.Kannada]: {
    icon: <Kannada height={20} width={20} />,
    name: 'Kannada',
  },
  [Locale.Malayalam]: {
    icon: <Malayalam height={20} width={20} />,
    name: 'Malayalam',
  },
}
